module.exports = __webpack_public_path__ + "static/media/skin-0.d7f242f0.svg";